import { render, staticRenderFns } from "./candidatFilters.vue?vue&type=template&id=27186538&"
import script from "./candidatFilters.vue?vue&type=script&lang=js&"
export * from "./candidatFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports